import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a44ee07a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-main" }
const _hoisted_2 = { class: "add-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Add Songs", -1))
const _hoisted_4 = { class: "add-container-row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add-row-label" }, "Folder", -1))
const _hoisted_6 = { class: "add-container-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add-row-label" }, "Songs", -1))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "loader"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader-circle" }, null, -1))
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "songs-container" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","text-align":"center"} }, "Are you sure you want to delete this song?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.folderName) = $event)),
          disabled: true
        }, null, 512), [
          [_vModelText, _ctx.folderName]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("input", {
          type: "file",
          ref: "fileInput",
          multiple: "",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.songChanged && _ctx.songChanged(...args))),
          accept: "audio/*",
          disabled: _ctx.loading
        }, null, 40, _hoisted_8)
      ]),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addClicked && _ctx.addClicked(...args))),
        disabled: _ctx.loading
      }, "Add", 8, _hoisted_9),
      _createElementVNode("div", {
        class: "error-message",
        innerHTML: _ctx.addErrorMessage
      }, null, 8, _hoisted_10),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", {
              class: "loader-text",
              innerHTML: _ctx.loadingText
            }, null, 8, _hoisted_13)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.songsList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Total of " + _toDisplayString(_ctx.songsList.length) + " songs", 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.songsList, (s, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "song-box"
        }, [
          _createElementVNode("div", null, _toDisplayString(s), 1),
          _createElementVNode("button", {
            style: {"color":"white","background":"red","height":"35px","cursor":"pointer"},
            onClick: ($event: any) => (_ctx.deleteSongClicked(s))
          }, "Delete", 8, _hoisted_16)
        ]))
      }), 128))
    ]),
    _createVNode(_component_Popup, {
      showPopup: _ctx.showDeletePopup,
      onButtonClicked: _ctx.deletePopupButtonClicked,
      title: "Delete Photo",
      buttons: [
        { buttonText: 'Delete', backgroundColor: 'red', color: 'white' },
        { buttonText: 'Cancel', backgroundColor: 'gray', color: 'white' },
      ]
    }, {
      default: _withCtx(() => [
        _hoisted_17
      ]),
      _: 1
    }, 8, ["showPopup", "onButtonClicked"])
  ]))
}